import TestimonialSlideshow from "@/layouts/auth/split-layout/testimonial-slideshow";

export default function AuthSplitLayoutImageSide() {
  return (
    <div className="relative hidden h-full w-full flex-col overflow-hidden p-4 pt-0 text-white lg:flex dark:border-r">
      <div className="relative h-full overflow-hidden rounded-xl bg-[url(/img/auth/side.jpg)] bg-bottom bg-cover bg-no-repeat">
        <div className="mask-t-from-55% absolute inset-x-0 bottom-0 h-84 bg-black/20 blur-2xl backdrop-blur-2xl" />
        <TestimonialSlideshow />
      </div>
    </div>
  );
}
